import { ITerceirizacaoRepository } from "../../repositories/terceirizacao_repository";
import { ICreateFuncionariosTercUseCase } from "../../../presentation/useCases/create/create_funcionario_terc_use_case";

// CreateFuncionariosTercUseCase

export class CreateFuncionariosTercUseCase implements ICreateFuncionariosTercUseCase {
  constructor(private readonly repository: ITerceirizacaoRepository) {}

  async createFuncionariosTerc(
    Ativo: boolean | null,
    Nome: string,
    IdCentroCusto: number | null,
    IdCargo: number | null,
    IdFornecedor: number | null,
    DataInicio: string | Date | null,
    DataTermino: string | Date | null,
    StatusAso: number | null,
    Salario: number | null,
    Cpf: string | null,
    Ctps: string | null,
    Serie: string | null,
    CtpsUf: string | null,
    DataEmissao: string | Date | null,
    RgUf: string | null,
    DataExpedicao: string | Date | null,
    OrgExp: string | null,
    Imagem: string | null,
    ExtensaoFoto: string | null,
    Observacoes: string | null,
    //Endereco
    Rua: string | null,
    Numero: string | null,
    Apartamento: string | null,
    Cep: string | null,
    Uf: string | null,
    Cidade: string | null,
    Bairro: string | null,
    Pais: string | null,
    dataNascimento: Date | null
  ): Promise<number> {
    const response = await this.repository.createFuncionariosTerc(
      Ativo,
      Nome,
      IdCentroCusto,
      IdCargo,
      IdFornecedor,
      DataInicio,
      DataTermino,
      StatusAso,
      Salario,
      Cpf,
      Ctps,
      Serie,
      CtpsUf,
      DataEmissao,
      RgUf,
      DataExpedicao,
      OrgExp,
      Imagem,
      ExtensaoFoto,
      Observacoes,
      //Endereco
      Rua,
      Numero,
      Apartamento,
      Cep,
      Uf,
      Cidade,
      Bairro,
      Pais,
      dataNascimento
    );

    return response.idFuncionarioTerc;
  }
}
